module.exports = __webpack_public_path__ + "static/media/Motorola Moto 360 Women Gold + Stone Closed.28ae40b6.png";